import React from 'react';
import Stack from '@mui/material/Stack';
import FloorPlanImage from '../assets/svgs/floor-plan';

export default function ({ onRoomClick }) {
    const onRoomSelected = (roomId) => {
        const roomOrder = ['', 'locker', 'staff', 'store', 'kitchen','nursing',  'staircase', 'open','living', 'rest', 'dining', 'library', 'office', 'reception', 'elevation', 'front']
        console.log(roomOrder.indexOf(roomId))
        onRoomClick(null, roomOrder.indexOf(roomId))
    }
    return <Stack style={{
        alignItems: 'center',
        margin: '10px'
    }}>
        <div style={{ maxWidth: '400px', width: '100%' }}>
            <FloorPlanImage onClick={onRoomSelected} />
        </div>
    </Stack>;
}